import { Dispatch, SetStateAction, useState } from 'react';
import {
  ButtonContainer,
  Container,
  InputWrapper,
  Title,
  TitleContainer,
} from './FinalPriceModal.styled';
import Button from 'components/Button/Button';
import { useBreakpointFlag } from 'utils/hooks/useBreakpointFlag';
import { useTranslation } from 'react-i18next';
import Input from 'components/Input/Input';
import { useCurrencySymbol } from 'utils/hooks/useFormatMoney';
import { validateFinalPriceValue } from './helpers';
import { Modal } from 'components/Modals/Modal/Modal';
import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';

interface FinalPriceModalProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  onConfirm: (discountValue: string) => void;
  disabled?: boolean;
  totalPrice: number;
}

const FinalPriceModal = ({
  isOpen,
  setIsOpen,
  onConfirm,
  disabled,
  totalPrice,
}: FinalPriceModalProps) => {
  const { t } = useTranslation();
  const { isSmallPhone, isPhone } = useBreakpointFlag();
  const [price, setPrice] = useState<string>('');
  const errorMessage = validateFinalPriceValue(price, t, totalPrice);

  const { currency } = useSelector(
    (state: IRootReducerState) => state.shoppingCartInfo
  );

  const currencySymbol = useCurrencySymbol(currency);

  return (
    <div onMouseDown={(e: any) => e.stopPropagation()}>
      <Modal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
        modalStyle={{
          margin: 'auto',
          width: isPhone ? '95%' : '500rem',
          minWidth: isPhone ? '95%' : 'auto',
          position: 'fixed',
        }}
      >
        <Container>
          <TitleContainer>
            <Title>{t('Set final net price')}</Title>
          </TitleContainer>

          <InputWrapper>
            <Input
              label=""
              placeholder=""
              value={price}
              errorMessage={errorMessage}
              width={'100%'}
              symbol={currencySymbol}
              hideNumberArrows
              type="text"
              wrapperStyles={{ width: '100%', maxWidth: '300rem' }}
              onChange={(e) => {
                const rawValue = e.target.value;
                const normalizedValue = rawValue.replace(',', '.');

                if (normalizedValue === '') {
                  setPrice(normalizedValue);
                  return;
                }

                const number = Number(normalizedValue);

                if (isNaN(number) || number < 0) {
                  return;
                }

                setPrice(normalizedValue);
              }}
              onBlur={() => {
                if (!price) return;

                const normalized = price.replace(',', '.');
                const number = parseFloat(normalized);

                if (isNaN(number) || number < 0) {
                  setPrice('');
                } else {
                  setPrice(number.toFixed(2));
                }
              }}
            />
          </InputWrapper>

          <ButtonContainer>
            <Button
              disabled={disabled}
              onClick={() => setIsOpen(false)}
              secondary
              width={isSmallPhone ? '150rem' : '200rem'}
              label={t('Cancel')}
            />
            <Button
              disabled={!price || !!errorMessage}
              onClick={() => onConfirm(price)}
              primary
              width={isSmallPhone ? '150rem' : '200rem'}
              label={t('Confirm')}
            />
          </ButtonContainer>
        </Container>
      </Modal>
    </div>
  );
};

export default FinalPriceModal;
